const colors = (value: string): string => value && `#${value.replace(/[#G-Zg-z]/g, '')}`;

export default colors;
